import TrendsPLPSlider from './TrendsPLPSlider';

export default TrendsPLPSlider;
// export type { TrendItem } from './TrendsPLPSlider';
